import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

import { ChaseOfferBoxStyled, ChaseOfferLinkBoxStyled } from './ValidationMessage.styles';

import { chaseOffers } from '../constants/messages';

const ChaseOffer = ({ hyperLink }) => {
  const navigate = useNavigate();

  const trackCancelPressed = useButtonPressedCallback({
    elementName: 'not_interested_in_chase_offer',
    elementText: 'No thanks',
    appPageName: 'banking_upsell_dashboard'
  });
  const handleCancel = () => {
    /**
     * Tracking Details: Tracking to be added on click of “No Thanks”
     * Question: How many customers  click on “No Thanks”?
     */
    trackCancelPressed();
    navigate('/dashboard');
  };

  const trackGoToChasePressed = useButtonPressedCallback({
    elementName: 'non_eligible_chase_offer',
    elementText: 'Learn more about Chase offer',
    appPageName: 'non_eligible_chase_offer'
  });
  const handleGoToChaseOffer = () => {
    /**
     * Tracking Details: Tracking to be added on click of “Learn more about Chase offer”
     * Question: How many customers view  this page?
     */
    trackGoToChasePressed();
  };

  return (
    <Stack pt="32px">
      <Stack spacing="16px">
        <Text
          color="primary"
          size="xl"
          weight="medium"
        >
          Chase Business Complete Banking®
        </Text>
        {chaseOffers.map((offer) => (
          <Stack
            alignItems="flex-start"
            direction="row"
            key={offer}
            spacing="8px"
          >
            <SharedAsset
              alt=""
              color="#FFB548"
              src="/s2/material-icons/boltrounded.svg"
              width="24px"
            />
            <Text
              color="tertiary"
              size="md"
            >
              {offer}
            </Text>
          </Stack>
        ))}
      </Stack>
      <ChaseOfferBoxStyled>
        <ChaseOfferLinkBoxStyled
          onClick={handleGoToChaseOffer}
          target="_blank"
          to={hyperLink}
        >
          <Text
            color="primary"
            size="md"
            weight="medium"
          >
            Learn more about Chase for Business offer
          </Text>
          <SharedAsset
            alt=""
            src="/icon/micro/external-link.svg"
          />
        </ChaseOfferLinkBoxStyled>
        <Stack
          alignItems="center"
          pt="32px"
        >
          <Text
            color="white"
            component="span"
            onClick={handleCancel}
            size="md"
            sx={{ cursor: 'pointer', width: 'fit-content' }}
            weight="medium"
          >
            No thanks
          </Text>
        </Stack>
      </ChaseOfferBoxStyled>
    </Stack>
  );
};
ChaseOffer.propTypes = {
  hyperLink: PropTypes.string.isRequired
};

export default ChaseOffer;
